import React, { useCallback, useEffect, useState } from "react";

import {
    Button,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    Typography
} from "@mui/material";
import styled from "styled-components";

type Props = {
    open: boolean
    onClose: () => void
    externalObservations?: string[]
    onConfirm: (observations: string[]) => void
}

const ChipContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: start;
  margin-top: 8px;
  flex-wrap: wrap;
`

export const QueryObservations: React.FC<Props> = ({ open, onClose, onConfirm, externalObservations }) => {

    const [newObservation, setNewObservation] = useState("")
    const [observations, setObservations] = useState<string[]>(externalObservations || [])

    useEffect(() => {
        setObservations(externalObservations || [])
    }, [externalObservations, open])

    const handleKeyPress = useCallback((event: React.KeyboardEvent) => {
        if (event.key === 'Enter' && newObservation.trim().length > 0) {
            event.preventDefault()
            setObservations([...observations, newObservation])
            setNewObservation("")
        }
    }, [setObservations, observations, newObservation, setNewObservation])

    const handleChipDelete = useCallback((feat: string) => {
        const newFeatures = observations.filter(value1 => value1 !== feat);
        setObservations(newFeatures)
    }, [observations, setObservations])

    return (
        <Dialog
            open={ open }
            onClose={ onClose }
            fullWidth={ true }
            PaperProps={{ sx: { m: 1, width: 'calc(100% - 16px)' } }}
        >
            <DialogTitle>Observações</DialogTitle>
            <DialogContent>
                <TextField
                    fullWidth
                    multiline
                    label="Observação"
                    variant="outlined"
                    helperText="Aperte Enter para incluir nova observação"
                    value={ newObservation }
                    onKeyPress={ event => handleKeyPress(event) }
                    onChange={ (e) => setNewObservation(e.target.value) }
                    sx={ { marginTop: "16px", width: '100%' } }/>

                <ChipContainer>
                    { observations.map((obs) => {
                        return <Chip
                            size="small"
                            variant="filled"
                            onDelete={ _ => handleChipDelete(obs) }
                            sx={ {
                                height: "auto",
                                maxWidth: "100%",
                                mt: 1,
                                "& .MuiChip-label": { whiteSpace: "normal", overflowWrap: "anywhere", py: 0.5 }
                            } }
                            label={ <Typography>{ obs }</Typography> }
                        />
                    }) }
                </ChipContainer>
            </DialogContent>

            <DialogActions>
                <Button onClick={ onClose }>Cancelar</Button>
                <Button onClick={ () => { onConfirm(observations)} } disabled={ newObservation.length > 0 }>Salvar</Button>
            </DialogActions>
        </Dialog>
    )
}